import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export enum AccountType {
  bank = 'BankAccount',
  cash = 'CashAccount',
}

export class IncomeCostLiteModel {
  id: string;
  type: string;

  @Type(() => Date)
  date: Date;
  description: string;
  total: number;
  isStatement: boolean;
  number: string;
}

export enum IncomeCostTypeEnum {
  income = 'income',
  cost = 'cost',
}

export class AccountableModel extends CommonModel {
  balance: string;
  code: string;
  description: string;
  name: string;

  @Expose({ name: 'account_number' })
  accountNumber: string;
}

export class IncomeCostModel {
  id: string;
  type: string;
  number: string;
  description: string;
  status: string;

  @Type(() => Date)
  date: Date;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'accountable_type' })
  accountableType: string;

  @Expose({ name: 'is_statement' })
  @Type(() => Boolean)
  isStatement: boolean;

  @Type(() => AccountableModel)
  accountable: AccountableModel;
}

export class getIncomeCostsInput {
  params: CommonParamInput;
}

export class getIncomeCostInput {
  id: string;
}

export class IncomeCostMutationInput {
  type: string;
  date: Date;
  description: string;
  total: number;
  isStatement: boolean;
}

export class IncomeCostUpdateInput {
  incomeCostId: string;
  body: IncomeCostMutationInput;
}

export class IncomeCostDeleteInput {
  incomeCostId: string;
}
